//
//
//
//
//
//
//
//
//
//

export default {
	name: 'Insure',
};
